import { faCheck, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { Checkbox, NumericTextBox } from "@progress/kendo-react-inputs";
import { IDropDownModel } from "../../../Shared/Models/IDropDownModel";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import { DatePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { CREATE_SHIFT_24HOURS_DURATION_ERROR_MSG, CREATE_SHIFT_SELECT_ATLEAST_ONE_WEEK, SCHEDULE_CREATE_PUBLISH_SHIFT_CONFIRMATION_MSG, SCHEDULE_CREATE_SHIFT_CONFIRMATION_MSG, SCHEDULE_SHIFT_CREATED_SUCCESS_MSG } from "../../../Shared/AppMessages";
import { addDays, errorToastr, localDateTime, RemoveSecFromTime, successToastr, toLocalDateTime } from "../../../../HelperMethods";
import { filterBy } from "@progress/kendo-data-query";
import { ErrorComponent } from "../../../ReusableComponents";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import Collapsible from "react-collapsible";
import { checkUntilInRecurrence, generateRecurrenceRule, isNullCheck } from "../../Common/Helper";
import Service from "../../Service/Service";
import auth from "../../../Auth";
import globalAdminService from "../../../Admin/GlobalAdmin/Service/DataService";
import { RecurrencePattern, weekDays } from "../../../Shared/AppConstants";
const defaultItem = { name: "Select...", id: null };

export enum ALLSELECTED {
    ALLDIVISIONS = "All Divisions",
    ALLLOCATIONS = "All Locations",
    ALLCATEGORIES = "All Categories",
    ALLPOSITIONS = "All Positions",
}

export interface CreateShiftProps {
    ScheduleId: string;
    onCloseModal?: any;
    onOpenModal: any;
    handleGetSchedule: any;
}

export interface CreateShiftState {
    clientId: string;
    name: string;
    noOfPosReq: number;
    duration: number;
    startTime: Date | null;
    endTime: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    recurrencePattern: number;
    recurrenceRule: string;
    recurEvery: number;
    submitted: boolean;
    isPublish: boolean;
    showLoader: boolean;
    showError: boolean;
    showCreateShiftSaveModal?: boolean;
    showCreateShiftSavePublishModal?: boolean;
    positions: any;
    originalpositions: Array<IDropDownModel>;
    jobCategories: any;
    originaljobCategories: Array<IDropDownModel>;
    jobCategory?: IDropDownModel;
    jobPosition?: IDropDownModel;
    selectedDays: string[];
    recurEveryMonth: number;
    shiftTypes: Array<IDropDownModel>;
    shiftType?: IDropDownModel;
}

class CreateShift extends React.Component<CreateShiftProps, CreateShiftState> {
    public totalDuration: any;
    constructor(props: CreateShiftProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            name: '',
            noOfPosReq: 0,
            duration: 0,
            startTime: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
            endTime: new Date(new Date(new Date().setHours(17)).setMinutes(30)),
            startDate: new Date(),
            endDate: addDays(new Date(), 30),
            recurrencePattern: 1,
            recurrenceRule: '',
            recurEvery: 1,
            submitted: false,
            isPublish: false,
            showLoader: false,
            showError: false,
            showCreateShiftSaveModal: false,
            showCreateShiftSavePublishModal: false,
            jobCategories: [],
            positions: [],
            originalpositions: [],
            originaljobCategories: [],
            selectedDays: ['MO', 'TU', 'WE', 'TH', 'FR'],
            jobCategory: { id: null, name: "Select" },
            jobPosition: { id: null, name: "Select" },
            recurEveryMonth: new Date().getDate(),
            shiftTypes:[]
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.getJobCategory();
        this.getShiftTypes()
    }

    getJobCategory = () => {
        const { clientId } = this.state;
        const queryParams = `status eq 'Active'&$orderby=name`;

        globalAdminService
            .getClientPositionCategories(clientId, queryParams)
            .then(async (res: any) => {
                this.setState({
                    jobCategories: res.data,
                    originaljobCategories: res.data,
                });
            });
    };

    onRecurrencePatternChange = (event) => {
        const newPattern = Number(event.target.value);
       // var pattern = newPattern == 1 ? RecurrencePattern.DAILY : newPattern == 2 ? RecurrencePattern.WEEKLY : RecurrencePattern.MONTHLY;
        //this.RecurrRule(pattern, this.state.recurEvery, this.state.selectedDays, this.state.endDate, this.state.recurEveryMonth);
        this.setState({ recurrencePattern: newPattern });
    };

    handleCheckboxChange = (day: string) => {
        if (this.state.recurrencePattern == 2) {
            var weekDays = this.state.selectedDays.includes(day)
                ? this.state.selectedDays.filter((d) => d !== day)
                : [...this.state.selectedDays, day];
            this.setState((prevState) => ({
                selectedDays: prevState.selectedDays.includes(day)
                    ? prevState.selectedDays.filter((d) => d !== day)
                    : [...prevState.selectedDays, day],
            }));
           // this.RecurrRule(RecurrencePattern.WEEKLY, this.state.recurEvery, weekDays, this.state.endDate);
        } else {
            this.setState({ selectedDays: [], recurEvery: 1 });
        }
    };

    openNew = () => {
        this.props.onOpenModal();
    };

    handleSave = () => {
        this.setState({ submitted: true });

        if(this.state.recurrencePattern == 2 && this.state.selectedDays.length == 0) {
            errorToastr(CREATE_SHIFT_SELECT_ATLEAST_ONE_WEEK);
            return false;
        }

        if (this.state.duration > 24) {
            errorToastr(CREATE_SHIFT_24HOURS_DURATION_ERROR_MSG);
            return false;
        }  

        var pattern = this.state.recurrencePattern;
        var rule = this.state.recurrenceRule;
        var shiftPattern = pattern == 1 ? RecurrencePattern.DAILY :
            pattern == 2 ? RecurrencePattern.WEEKLY : RecurrencePattern.MONTHLY;
        
        var interval=1;
        if(pattern == 2) {
            interval = this.state.recurEvery;
        }

        // var interval = pattern == 1 ? RecurrencePattern.MONTHLY || RecurrencePattern.DAILY ? 1 : this.state.recurEveryMonth : 1;
        rule = generateRecurrenceRule(shiftPattern, interval, this.state.selectedDays, localDateTime(this.state.endDate).toString(), this.state.recurEveryMonth);

        let data: any = {
            scheduleId: this.props.ScheduleId,
            name: this.state.name,
            positionId: this.state.jobPosition.id,
            noOfPosReq: this.state.noOfPosReq,
            duration: this.totalDuration,
            startTime: toLocalDateTime(this.state.startTime),
            endTime: toLocalDateTime(this.state.endTime),
            startDate: this.state.startDate ? localDateTime(this.state.startDate) : null,
            endDate: this.state.endDate ? localDateTime(this.state.endDate) : null,
            recurrenceRule: rule,
            isPublish: this.state.isPublish,
            shiftTypeId: this.state.shiftType.id
        };
        
        Service.postScheduleShift(data)
            .then((res: any) => {
                if (res.status === 200) {
                    successToastr(SCHEDULE_SHIFT_CREATED_SUCCESS_MSG);
                    this.props.onCloseModal();
                    this.props.handleGetSchedule(this.props.ScheduleId);
                }
            });
        
    };

    checkValidations = (isPublish) => {
        if (!this.state.name || !this.state.jobCategory.id || !this.state.jobPosition.id
            || !this.state.startTime || !this.state.endTime || !this.state.startDate
            || !this.state.endDate || !this.state.noOfPosReq) {
            this.setState({ showError: true });
            return false;
        }

        if (isPublish) {
            this.setState({ showCreateShiftSavePublishModal: true, isPublish: isPublish, showError: false });
        } else {
            this.setState({ showCreateShiftSaveModal: true, isPublish: false, showError: false });
        }
        return true;
    };

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }
    
    // Event handlers
    handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target;
        this.setState(prevState => ({
            ...prevState,
            [name]: type === 'number' ? Number(value) : value
        }));
        
       // var pattern: "DAILY" | "WEEKLY" | "MONTHLY"
       // pattern = this.state.recurrencePattern == 1 ? "DAILY" : this.state.recurrencePattern == 2 ? "WEEKLY" : "MONTHLY";

        // if (name === "recurEvery") {
        //     this.RecurrRule(pattern, value, this.state.selectedDays, this.state.endDate);
        // }
        // if (name === "recurEveryMonth") {
        //     this.RecurrRule('MONTHLY', 1, this.state.selectedDays, this.state.endDate, e.target.value);
        // }
    };

    // RecurrRule = (pattern, recurEvery, selectedDays, endDate, dayOfMonth?) => {
    //     var rule = generateRecurrenceRule(pattern, recurEvery, selectedDays, endDate, dayOfMonth);
    //     this.setState({ recurrenceRule: rule });
    // }

    handleTimeChange = (e: any, field: 'startTime' | 'endTime') => {
        this.setState((prevState: CreateShiftState) => ({
            ...prevState,
            [field]: e.value
        } as CreateShiftState));       
    };

    handleDateChange = (e: any, field: 'startDate' | 'endDate') => {
        this.setState((prevState: CreateShiftState) => ({
            ...prevState,
            [field]: e.value
        } as CreateShiftState));
        // if (field === 'endDate') {
        //     if(this.state.recurrencePattern == 3) {
        //         this.RecurrRule('MONTHLY', 1, [],  e.value, this.state.recurEveryMonth);
        //     }
        //     else if(this.state.recurrencePattern == 2) {
        //         this.RecurrRule('WEEKLY', this.state.recurEvery, this.state.selectedDays, e.value);
        //     }
        //     else{
        //         this.RecurrRule('DAILY', 1, [], e.value);
        //     }
            
        // }

        // if(field === 'startDate' ){
        //     if(this.state.recurrencePattern == 3) {
        //         this.RecurrRule('MONTHLY', 1, [], this.state.endDate, this.state.recurEveryMonth);
        //     }
        //     else if(this.state.recurrencePattern == 2) {
        //         this.RecurrRule('WEEKLY', this.state.recurEvery, this.state.selectedDays, this.state.endDate);
        //     }
        //     else{
        //         this.RecurrRule('DAILY', 1, [], this.state.endDate);
        //     }
            
        // }
    };

    getPositions = (Ids) => {
        Service.getJobcatpositions(this.state.clientId, Ids)
            .then(async (res: any) => {
                this.setState({ positions: res.data, originalpositions: res.data });
                this.handleObjChange({
                    positionId: null
                });
            });
    };

    handleJobCategoryChange = (e) => {
        const jobCategory = e.target.value;
        this.handleObjChange({ jobCategory: jobCategory, jobPosition: { id: null, name: "Select..." } });
        if (jobCategory.id != null) {
            this.getPositions(jobCategory.id);
        } else {
            this.setState({ positions: [] });
        }
    };

    // handling jobPosition cascade dropdown change
    handleJobPositionChange = (e) => {
        const jobPosition = e.target.value;
        this.handleObjChange({ jobPosition: jobPosition });
    };

    handleObjChange = (change) => {
        change["isDirty"] = true;
        this.setState(change);
    };

    handleRecurEveryChange = (e) => {
        this.setState({ recurEvery: e.value });
    }

    getShiftTypes = () => {
        Service.getShiftTypeLookup()
            .then(async res => {
                this.setState(
                    { 
                        shiftTypes: res.data,
                        shiftType: res.data.find( item => item.isDefault === true ) || res.data[0]
                    } 
                );
            });
    }

    handleShiftTypeChange = (e) => {
        this.setState({
            shiftType: e.target.value
        })
      
    };

    render() {
        const {
            name,
            positions, originalpositions,
            jobCategories, originaljobCategories,
            startDate, endDate,
            noOfPosReq, startTime, endTime,
            jobCategory, jobPosition,
            showError
        } = this.state;
        // let totalDuration = 0;
        // let timeOut = RemoveSecFromTime(this.state.endTime);
        // let timeIn = RemoveSecFromTime(this.state.startTime);
        // totalDuration = (timeOut - timeIn) / 36e5;

        this.totalDuration = 0;
        let timeOut = RemoveSecFromTime(this.state.endTime);
        let timeIn = RemoveSecFromTime(this.state.startTime);
        if ((this.state.endTime != null || this.state.endTime != undefined) && this.state.endTime < this.state.startTime) {
            timeOut = new Date(this.state.endTime).setDate(new Date(this.state.endTime).getDate() + 1);
            timeOut = RemoveSecFromTime(timeOut);
        }
        this.totalDuration = (timeOut - timeIn) / 36e5;
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width createShiftPopUp">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">Create Shift</h4>
                        <button type="button" className="close text-white close_opacity"
                            data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>

                    {this.state.showLoader &&
                        Array.from({ length: 3 }).map((item, i) => (
                            <div className="row col-12 mx-auto mt-2" key={i}>
                                {Array.from({ length: 3 }).map((item, j) => (
                                    <div className="col-12 col-sm-6 col-lg-4 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={100} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div className="col-12 px-4 newShift-inner-content mt-3">
                            <Collapsible
                                trigger="Shift Details"
                                open={true}
                            >
                                <div className="row mt-2 ">
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-1">
                                        <label className="mb-1 font-weight-bold required">Shift Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Enter Shift Name"
                                            maxLength={100}
                                            value={name}
                                            onChange={this.handleInputChange}
                                        />
                                        {showError && (!isNullCheck(name) || name == '' || !name) && <ErrorComponent />}
                                    </div>

                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-1">
                                        <label className="mb-0 font-weight-bold required">Shift Type</label>
                                        <DropDownList
                                            className={"form-control"}
                                            data={this.state.shiftTypes}
                                            value={this.state.shiftType}
                                            textField="name"
                                            dataItemKey="id"
                                            onChange={(e) => this.handleShiftTypeChange(e)}
                                            id="shiftTypes"
                                            name="shiftType"
                                        />
                                    </div>

                                </div>
                                <div className="row mt-2 ">
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-1 multiselect">
                                        <label className="mb-1 font-weight-bold required">Job Category</label>
                                        <DropDownList
                                            className={"form-control"}
                                            data={jobCategories}
                                            name="jobCategory"
                                            textField="name"
                                            dataItemKey="id"
                                            id="jobCategories"
                                            defaultItem={defaultItem}
                                            value={jobCategory}
                                            onChange={(e) => this.handleJobCategoryChange(e)}
                                            filterable={originaljobCategories.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {showError && !isNullCheck(jobCategory.id) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                        <label className="mb-1 font-weight-bold required">Position</label>
                                        <DropDownList
                                            className="form-control"
                                            data={positions}
                                            name="jobPosition"
                                            textField="name"
                                            dataItemKey="id"
                                            id="positions"
                                            defaultItem={defaultItem}
                                            value={jobPosition}
                                            onChange={(e) => this.handleJobPositionChange(e)}
                                            filterable={originalpositions.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                        />
                                        {showError && !isNullCheck(jobPosition.id) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-1">
                                        <div className="row">
                                        <div className="col-8 pr-2">
                                            <label className="mb-1 font-weight-bold required">No of Position Required</label>
                                            <input
                                                type="number"
                                                name="noOfPosReq"
                                                className="form-control"
                                                placeholder="Enter no of positions"
                                                value={noOfPosReq}
                                                min={1}
                                                onChange={this.handleInputChange}
                                            />
                                            {showError && (!isNullCheck(noOfPosReq) || noOfPosReq <= 0) && <ErrorComponent />}
                                        </div>
                                        <div className="col-4 pl-0">
                                                <label className="mb-1 font-weight-bold">Duration(hrs)</label>
                                                <NumericTextBox
                                                    className="form-control text-right"
                                                    disabled={true}
                                                    name="duration"
                                                    placeholder="Enter Duration"
                                                    value={isNaN(this.totalDuration) ? 0 : this.totalDuration}
                                                    title="Maximum value could be 99999."
                                                    max={99999}
                                                    min={0}
                                                    spinners={false}
                                                />
                                           
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2 ">
                                    <div className="col-12 col-sm-8 col-lg-8 mt-sm-0 mt-1">
                                    <div className="row">
                                        <div className="col-6 mt-sm-0 mt-1">
                                            <label className="mb-1 font-weight-bold required">Start Date</label>
                                            <DatePicker
                                                className="form-control"
                                                format="MM/dd/yyyy"
                                                name="startDate"
                                                min={new Date()}
                                                value={startDate}
                                                onChange={(e) => this.handleDateChange(e, 'startDate')}
                                                formatPlaceholder="formatPattern"
                                            />
                                        </div>
                                        <div className="col-6 mt-sm-0 mt-1 ">
                                           
                                            <label className="mb-1 font-weight-bold required">End Date</label>
                                            <DatePicker
                                                className="form-control"
                                                format="MM/dd/yyyy"
                                                name="endDate"
                                                value={endDate != undefined && endDate !== null ? new Date(endDate) : null}
                                                onChange={(e) => this.handleDateChange(e, 'endDate')}
                                                formatPlaceholder="formatPattern"
                                                min={new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1))}
                                            />
                                            
                                        </div>
                                    </div>
                                    </div>
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-1">
                                        <div className="row">
                                            <div className="col-6 pr-2">
                                            <label className="mb-1 font-weight-bold required">Start Time</label>
                                            <TimePicker
                                                className="form-control"
                                                format="hh:mm a"
                                                name="startTime"
                                                value={new Date(startTime)}
                                                // max={new Date(endTime)}
                                                onChange={(e) => this.handleTimeChange(e, 'startTime')}
                                            />
                                            </div>
                                            <div className="col-6 pl-2">
                                            <label className="mb-1 font-weight-bold required">End Time</label>
                                            <TimePicker
                                                className="form-control "
                                                format="hh:mm a"
                                                name="endTime"
                                                // min={new Date(startTime)}
                                                value={new Date(endTime)}
                                                onChange={(e) => this.handleTimeChange(e, 'endTime')}
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapsible>
                            <Collapsible
                                trigger="Recurrence Pattern"
                                open={true}
                            >
                                <div className="row mt-2 mx-0">
                                    <div className="col-12 col-sm-6 col-lg-3 mt-2  ">
                                        <div className="d-flex flex-column mb-2 mb-sm-0">
                                            <label className="container container_checkboxandradio radioBtnCustom font-weight-bold">
                                                Daily
                                                <input
                                                    type="radio"
                                                    name="recurrencePattern"
                                                    value="1"
                                                    checked={this.state.recurrencePattern === 1}
                                                    onChange={this.onRecurrencePatternChange}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className="container container_checkboxandradio radioBtnCustom font-weight-normal">
                                                Weekly
                                                <input
                                                    type="radio"
                                                    name="recurrencePattern"
                                                    value="2"
                                                    checked={this.state.recurrencePattern === 2}
                                                    onChange={this.onRecurrencePatternChange}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className="container container_checkboxandradio radioBtnCustom font-weight-normal">
                                                Monthly
                                                <input
                                                    type="radio"
                                                    name="recurrencePattern"
                                                    value="3"
                                                    checked={this.state.recurrencePattern === 3}
                                                    onChange={this.onRecurrencePatternChange}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    {this.state.recurrencePattern == 2 &&(
                                        <div className="col-12 col-sm-6 col-lg-9 mt-2">
                                            <div className="row mb-2">
                                            <div className="col-5 d-flex">
                                                <label className="font-weight-bold">Recur Every</label>
                                                <NumericTextBox
                                                    className="form-control mx-2 recurEveryInput"
                                                    name="recurEvery"
                                                    value={this.state.recurEvery}
                                                    onChange={(e) => this.handleRecurEveryChange(e)}
                                                    title="Maximum value could be 10."
                                                    max={10}
                                                    min={1}
                                                    format="n0"
                                                />
                                                <label className="font-weight-bold"> Weeks On: </label>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            {weekDays.map((day) => (
                                                <div className="col-3">
                                                <Checkbox className="mr-3 mb-2"                                           
                                                    key={day.value}
                                                    label={day.label}
                                                    checked={this.state.selectedDays.includes(day.value)}
                                                    onChange={() => this.handleCheckboxChange(day.value)}
                                                />
                                                </div>
                                            ))}
                                        </div>
                                    </div>)}
                                    {this.state.recurrencePattern == 3 &&(
                                        <div className="col-12 col-sm-6 col-lg-9 mt-2">
                                            <div className="row mb-2">
                                            <div className="col-12 d-flex">
                                                <label className="font-weight-bold">Recur every</label>
                                                <input
                                                    type="number"
                                                    name="recurEveryMonth"
                                                    className="form-control mx-2 recurEveryInput"
                                                    style={{ width: '60px' }}
                                                    min={1}
                                                    max={31}
                                                    value={this.state.recurEveryMonth}
                                                    onChange={this.handleInputChange}
                                                />
                                                <label className="font-weight-bold"> day of the month</label>
                                            </div>
                                        </div>
                                    </div>)}
                                </div>
                            </Collapsible>                          
                        </div>
                    )}
                    <div className="modal-footer justify-content-center border-0 mt-lg-0 mb-lg-0 mt-xxl-3 mb-xxl-3">
                        <div className="row mt-0 mb-0 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => { this.checkValidations(false) }}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                            </button>
                            <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => { this.checkValidations(true) }}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save and Publish
                            </button>
                        </div>
                    </div>
                    <ConfirmationModal
                        message={SCHEDULE_CREATE_SHIFT_CONFIRMATION_MSG()}
                        showModal={this.state.showCreateShiftSaveModal}
                        handleYes={() => {
                            this.setState({ showCreateShiftSaveModal: false });
                            this.handleSave()
                        }}
                        handleNo={() => {
                            this.setState({ showCreateShiftSaveModal: false });
                        }}
                    />
                    <ConfirmationModal
                        message={SCHEDULE_CREATE_PUBLISH_SHIFT_CONFIRMATION_MSG()}
                        showModal={this.state.showCreateShiftSavePublishModal}
                        handleYes={() => {
                            this.setState({ showCreateShiftSavePublishModal: false });
                            this.handleSave()
                        }}
                        handleNo={() => {
                            this.setState({ showCreateShiftSavePublishModal: false });
                        }}
                    />
                </div>
            </div>
        );
    }
}
export default CreateShift;
